module.exports = __webpack_public_path__ + "static/media/about.e08bcd87.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/about.png
// module id = 258
// module chunks = 0